import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Button } from '@repo/ui/button';
import { Dialog, DialogContent, DialogTitle } from '@repo/ui/dialog';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

type DepositInfoModalProps = {
  open: boolean;
};

const DepositInfoModal = ({ open }: DepositInfoModalProps) => {
  const t = useTranslations('deposits.info-modal');

  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <DialogContent
        className="z-[var(--z-payment-deposit-info-modal)] max-w-96 space-y-4 rounded-xl p-9 vt-surface-default-bg"
        portalOverlayClassName="z-[var(--z-payment-deposit-info-modal-overlay)]"
        aria-describedby="deposit-info-modal"
      >
        <VisuallyHidden>
          <DialogTitle />
        </VisuallyHidden>
        <section className="flex flex-col gap-2">
          <ul className="flex flex-col gap-4 rounded-sm border-[0.5px] border-[#eeeeee4d] p-4">
            {t('bullet-point-1') && (
              <li className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white" />
                <div className="text-left text-white vt-text-size-medium sm:vt-text-size-medium-sm rtl:text-right">
                  {t('bullet-point-1')}
                </div>
              </li>
            )}
            {t('bullet-point-2') && (
              <li className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white" />
                <div className="text-left text-white vt-text-size-medium sm:vt-text-size-medium-sm rtl:text-right">
                  {t('bullet-point-2')}
                </div>
              </li>
            )}
            {t('bullet-point-3') && (
              <li className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white" />
                <div className="text-left text-white vt-text-size-medium sm:vt-text-size-medium-sm rtl:text-right">
                  {t('bullet-point-3')}
                </div>
              </li>
            )}
            {t('bullet-point-4') && (
              <li className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white" />
                <div className="text-left text-white vt-text-size-medium sm:vt-text-size-medium-sm rtl:text-right">
                  {t('bullet-point-4')}
                </div>
              </li>
            )}
            {t('bullet-point-5') && (
              <li className="flex items-start gap-2">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white" />
                <div className="text-left text-white vt-text-size-medium sm:vt-text-size-medium-sm rtl:text-right">
                  {t('bullet-point-5')}
                </div>
              </li>
            )}
          </ul>
        </section>
        <Button
          className="w-full rounded-3xl"
          onClick={() => setIsOpen(false)}
        >
          {t('button-label')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DepositInfoModal;
